import request from '@/utils/request'

// 获取管理员列表
export const getList = (params: any) =>
  request({
    url: '/manage/manager',
    method: 'get',
    params
  })

// 获取管理员信息详情
export const getInfo = (params: any) =>
  request({
    url: '/manage/manager/' + params,
    method: 'get'
  })

// 编辑管理员信息
export const setInfo = (data: any) =>
  request({
    url: '/manage/manager/' + data.id,
    method: 'patch',
    data
  })

// 删除管理员
export const delInfo = (data: any) =>
  request({
    url: '/manage/manager/' + data.id,
    method: 'delete',
    data
  })

// 新增管理员
export const createAdmin = (data: any) =>
  request({
    url: '/manage/manager',
    method: 'post',
    data
  })

// 获取菜单权限列表
export const getMenuAuthList = (params: any) =>
  request({
    url: '/manage/manager/' + params.id + '/authorize/menu',
    method: 'get',
    params
  })

// 授权
export const setAuth = (data: any) =>
  request({
    url: '/manage/manager/' + data.id + '/authorize/menu',
    method: 'post',
    data
  })

// 绑定 Google 验证码
export const bindCode = (data: any) =>
  request({
    url: '/manage/manager/' + data.id + '/show/secret',
    method: 'patch',
    data
  })

// 修改 Google 验证码
export const resetCode = (data: any) =>
  request({
    url: '/manage/manager/' + data.id + '/reset/secret',
    method: 'put',
    data
  })

// 机器人绑定 Google 验证码
export const bindBotCode = (data: any) =>
  request({
    url: '/manage/manager/' + data.id + '/show/bot-secret',
    method: 'PATCH',
    data
  })

// 重置 机器人 Google 验证码
export const resetBotCode = (data: any) =>
  request({
    url: '/manage/manager/' + data.id + '/reset/bot-secret',
    method: 'put',
    data
  })

// 日志信息
export const getLogList = (params: any) =>
  request({
    url: '/manage/manager-action-log',
    method: 'get',
    params
  })

// 任务计数
export const getTaskCenter = () =>
  request({
    url: '/manage/task-center',
    method: 'get'
  })

// 重置 Google 验证码
export const resetGoogleCode = (data: any) =>
  request({
    url: '/manage/merchant/manager/' + data.id + '/reset/secret',
    method: 'put',
    data
  })

// 登录日志
export const getloginLog = (params: any) =>
  request({
    url: '/manage/manager/login-log',
    method: 'get',
    params
  })
